<template>
  <div id="aContent">
    <div id="hpc">
      <div id="lbimg"><img style="width: 100%;height: 100%;" src="../assets/exhibitioninfo/exhibitioninfo-top.jpg"></div>
      <div id="aTow">
        <div id="navContents">
          <div id="navBtn">
            <div>
              <router-link id="nav2" tag="div" :to="{path:'/exhibitioninfo/permanent'}"><span id="text2">常设展览</span></router-link>
              <router-link id="nav3" tag="div" :to="{path:'/exhibitioninfo/thematic'}"><span id="text3">专题展览</span></router-link>
              <router-link id="nav1" tag="div" :to="{path:'/exhibitioninfo/exchange'}"><span id="text1">交流展览</span></router-link>
              <router-link id="nav4" tag="div" :to="{path:'/exhibitioninfo/vr'}"><span id="text4">数字展览</span></router-link>
              <router-link id="nav5" tag="div" :to="{path:'/exhibitioninfo/micro'}"><span id="text5">微展览</span></router-link>
            </div>
            <div id="imgss"><img style="width: 100%;" src="../assets/img/nb.png"></div>
            <div id="daolan">
              <p>游览须知</p>
              <p>开放时间:周二至周日9:00-17:00(16:30停止入场)法定节假日无特殊情况正常开放，逢周一闭馆，节假日及其他重要活动等特殊情况将提前公告开放时间。参观咨询电话:0971-6111326</p>
              <!-- <p>2、法定节假日无特殊情况正常开放，逢周一闭馆，节假日，其他重要活动等特殊情况将提前公告开放时间。</p> -->
              <p style="color: #FF4500;">温馨提示：参观人员均需凭预约码入馆</p>
            </div>
            <router-link tag="div" id="defdl" :to="{path:'/about/tourguide'}">进入游览详情</router-link>
          </div>
          <div id="eCon">
            <router-view></router-view>
          </div>
        </div>
        <div style="clear: both;"></div>
      </div>
    </div>
    <div id="hmobile">
      <div style="width: 100%;height: 150px;"><img style="width: 100%;height: 100%;" src="../assets/exhibitioninfo/exhibitioninfo-top.jpg"></div>
      <div id="maTow">
        <div id="mnavContents">
          <div id="mnavBtn">
            <div>
              <router-link style="float: left;" tag="div" :to="{path:'/exhibitioninfo/permanent'}"><span>常设展览</span></router-link>
              <router-link style="float: left;" tag="div" :to="{path:'/exhibitioninfo/thematic'}"><span>专题展览</span></router-link>
              <router-link style="float: left;" tag="div" :to="{path:'/exhibitioninfo/exchange'}"><span>交流展览</span></router-link>
              <router-link style="float: left;" tag="div" :to="{path:'/exhibitioninfo/vr'}"><span>数字展览</span></router-link>
              <router-link style="float: left;" tag="div" :to="{path:'/exhibitioninfo/micro'}"><span>微展览</span></router-link>
            </div>
          </div>
          <div id="meCon">
            <router-view></router-view>
          </div>
        </div>
        <div style="clear: both;"></div>
      </div>
    </div>
  </div>

</template>

<script>
  export default {
    data() {
      return {}
    },
    methods: {
      isMobile() {
        let flag = navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        )
        return flag;
      },
      handleSearch() {
        let eWidth = document.body.clientWidth;
        document.getElementById("hpc").style.width = eWidth + "px";
        document.getElementById("aTow").style.marginLeft = (eWidth - eWidth * 0.9) / 2 + "px";
        document.getElementById("aTow").style.marginRight = (eWidth - eWidth * 0.9) / 2 + "px";
        document.getElementById("lbimg").style.width = eWidth + "px";
        document.getElementById("lbimg").style.height = eWidth * 0.35 + "px";
        document.getElementById("eCon").style.width = eWidth * 0.72 + "px";
        document.getElementById("navBtn").style.width = eWidth * 0.18 + "px";
        document.getElementById("navContents").style.width = eWidth * 0.9 + "px";
        document.getElementById("navContents").style.marginTop = "20px";
        for (var i = 1; i < 6; i++) {
          document.getElementById("nav" + i + "").style.width = eWidth * 0.18 + "px";
          document.getElementById("nav" + i + "").style.height = (eWidth * 0.18) / 5 + 17 + "px";
          document.getElementById("text" + i + "").style.top = ((eWidth * 0.18) / 5 - 13) / 2 + "px";
        };
        document.getElementById("imgss").style.width = eWidth * 0.18 + "px";
        document.getElementById("imgss").style.marginTop = "10px";
        document.getElementById("daolan").style.width = eWidth * 0.18 + "px";
        document.getElementById("daolan").style.textAlign = "left";
      },
      updated() {
        window.scroll(0, 0);
      }
    },
    mounted() {
      $("body,html").animate({
        scrollTop: 0
      }, 1);
      if (this.isMobile()) {
        document.getElementById("hmobile").style.display = "block"
        if (location.href.indexOf("#reloaded") == -1) {
          location.href = location.href + "#reloaded";
          location.reload();
        }
      } else {
        document.getElementById("hpc").style.display = "block";
        this.handleSearch();
        this.updated();
      }
    }
  }
</script>

<style scoped>
  #aContent {
    background: rgba(255, 255, 255, 0.6);
  }

  #hpc {
    display: none;
  }

  #hpc>#aTow>#aNav {
    text-align: left;
    height: 48px;
    line-height: 48px;
  }

  #hpc>#aTow>#aNav>span:nth-child(1) {
    cursor: pointer;
  }

  #hpc>#aTow>#aNav>span:nth-child(1):hover {
    color: #FF9900;
  }

  #hpc>#aTow>div:nth-child(1)>img {
    width: 100%;
    height: 100%;
  }

  #hpc>#aTow>div:nth-child(1)>span {
    width: 380px;
    height: 150px;
    font-size: 50px;
  }

  #hpc>#aTow>div:nth-child(1)>div:nth-child(1) {
    float: left;
  }

  #eCon {
    float: left;
  }

  #hpc>#aTow>div:nth-child(1)>div:nth-child(1)>div:nth-child(1)>div:nth-child(1) {
    cursor: pointer;
    color: rgb(176, 153, 138);
    background-image: url(../assets/navback/navback-1.png);
    border-bottom: 1px solid #FFFFFF;
    position: relative;
    background-size: cover;
  }

  #nav1>span,
  #nav2>span,
  #nav3>span,
  #nav4>span,
  #nav5>span{
    position: absolute;
    left: 0;
    right: 0;
    line-height: 30px;
    font-size: 1.3em;
  }

  #hpc>#aTow>div:nth-child(1)>div:nth-child(1)>div:nth-child(1)>div:nth-child(2) {
    cursor: pointer;
    color: rgb(176, 153, 138);
    background-image: url(../assets/navback/navback-2.png);
    border-bottom: 1px solid #FFFFFF;
    position: relative;
    background-size: cover;
  }

  #hpc>#aTow>div:nth-child(1)>div:nth-child(1)>div:nth-child(1)>div:nth-child(3) {
    cursor: pointer;
    color: rgb(176, 153, 138);
    background-image: url(../assets/navback/navback-3.png);
    border-bottom: 1px solid #FFFFFF;
    position: relative;
    background-size: cover;
  }

  #hpc>#aTow>div:nth-child(1)>div:nth-child(1)>div:nth-child(1)>div:nth-child(4) {
    cursor: pointer;
    color: rgb(176, 153, 138);
    background-image: url(../assets/navback/navback-4.png);
    border-bottom: 1px solid #FFFFFF;
    position: relative;
    background-size: cover;
  }
  #hpc>#aTow>div:nth-child(1)>div:nth-child(1)>div:nth-child(1)>div:nth-child(5) {
    cursor: pointer;
    color: rgb(176, 153, 138);
    background-image: url(../assets/navback/navback-5.png);
    border-bottom: 1px solid #FFFFFF;
    position: relative;
    background-size: cover;
  }

  #hpc>#aTow>div:nth-child(1)>div:nth-child(1)>div:nth-child(1)>div:nth-child(1):hover {
    background-image: url(../assets/navback/q2navback1.png);
    color: white;
    background-size: cover;
  }

  #hpc>#aTow>div:nth-child(1)>div:nth-child(1)>div:nth-child(1)>div:nth-child(2):hover {
    background-image: url(../assets/navback/q2navback2.png);
    color: white;
    background-size: cover;
  }

  #hpc>#aTow>div:nth-child(1)>div:nth-child(1)>div:nth-child(1)>div:nth-child(3):hover {
    background-image: url(../assets/navback/q2navback3.png);
    color: white;
    background-size: cover;
  }

  #hpc>#aTow>div:nth-child(1)>div:nth-child(1)>div:nth-child(1)>div:nth-child(4):hover {
    background-image: url(../assets/navback/q2navback4.png);
    color: white;
    background-size: cover;
  }
  #hpc>#aTow>div:nth-child(1)>div:nth-child(1)>div:nth-child(1)>div:nth-child(5):hover {
    background-image: url(../assets/navback/q2navback5.png);
    color: white;
    background-size: cover;
  }

  #hpc>#aTow>div:nth-child(2)>div:nth-child(2)>div:nth-child(1) {
    width: 82%;
    float: left;
  }

  #daolan {
    margin-top: 10px;
    text-align: left;
    line-height: 30px;
    border-radius: 1px solid #A9A9A9;
  }

  p {
    margin: 0;
  }

  #defdl {
    width: 60%;
    height: 30px;
    margin: 20px 20%;
    background: #FF9900;
    line-height: 30px;
    cursor: pointer;
    color: #ffffff;
  }

  #defdl:hover {
    background: #FF0000;
  }

  /*mobile*/

  #hmobile {
    background: rgba(255, 255, 255, 0.6);
    display: none;
  }

  #mnavBtn {
    height: 120px;
    line-height: 60px;
    margin: 0 auto;
    width: 100%;
    border-bottom: 1px solid #956f17;
  }

  #mnavBtn>div>div {
    float: left;
    width: 33.3%;
    cursor: pointer;
  }

</style>



// WEBPACK FOOTER //
// src/pages/Exhibitioninfo.vue